import session_svg from "../assets/progressSession.svg"
import strokes_svg from "../assets/Heart reate.svg"
import calories_svg from "../assets/progressSession.svg"

const stats = [
  {
    heading: "Total Sessions",
    info_data: "15/20",
    info_unit: "sessions",
    emoji_icon: "🏓",
    svg_img: session_svg,
    style: "center"
  },
  {
    heading: "Number of strokes performed",
    info_data: "120",
    info_unit: "Strokes",
    emoji_icon: "❤️",
    svg_img: strokes_svg,
  },
  {
    heading: "Accuracy",
    info_data: "15/20",
    info_unit: "%",
    emoji_icon: "💪",
  },
  {
    heading: "Calories",
    info_data: "990",
    info_unit: "KCal",
    emoji_icon: "🔥",
    svg_img: calories_svg,
    style: "center"
  },
  {
    heading: "Average Speed",
    info_data: "50",
    info_unit: "Km/h",
    emoji_icon: "🚗",
  },
]

export const getProgress = () => {
  return stats;
};
